// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "wrapper-3OrsF";
var _5 = "header-1ShuM";
var _6 = "passenger-2Eode";
var _7 = "seats__icon-el5yT";
var _8 = "downloadButton-yIPTh";
var _9 = "actions__buttons-1xiek";
var _a = "downloadIcon-2VsUm";
var _b = "footerActions-3jqj2";
var _c = "footerActions__cancel-Y5RTU";
var _d = "appleWallet-3kDpb";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "wrapper", _5 as "header", _6 as "passenger", _7 as "seats__icon", _8 as "downloadButton", _9 as "actions__buttons", _a as "downloadIcon", _b as "footerActions", _c as "footerActions__cancel", _d as "appleWallet" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "wrapper": _4, "header": _5, "passenger": _6, "seats__icon": _7, "downloadButton": _8, "actions__buttons": _9, "downloadIcon": _a, "footerActions": _b, "footerActions__cancel": _c, "appleWallet": _d }
